import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urljoin from "url-join";

export const alternatedMaterialUrl = "/alternated-material";
export const addAlternatedMaterialUrl = `${alternatedMaterialUrl}/add-alternated-material`;
export const logChangeUrl = `${alternatedMaterialUrl}/log-change`;
export const editdAlternatedMaterialUrl = `${alternatedMaterialUrl}/edit-alternated-material/:id`;
export const editdAlternatedWithoutIDUrl = `${alternatedMaterialUrl}/edit-alternated-material/`;

export enum AltMatSortField {
  SALE_ORG = "SALE_ORG",
  SOLD_TO = "SOLD_TO",
  MATERIAL_INPUT = "MATERIAL_INPUT",
  ALTERNATED_MATERIAL = "ALTERNATED_MATERIAL",
  DIA = "DIA",
  TYPE = "TYPE",
  PRIORITY = "PRIORITY",
  LAST_UPDATED_DATE = "LAST_UPDATED_DATE",
  LAST_UPDATED_BY = "LAST_UPDATED_BY"
}

export const altMatSection = "/alternated-material";

export type AltMatUrlSort = Sort<AltMatSortField>;
export type AltMatUrlQueryParams = Pagination & AltMatUrlSort;

export const AltMatListUrl = (params?: AltMatUrlQueryParams) =>
  altMatSection + "?" + stringifyQs(params);

export const altMatPath = (id: string) => urljoin(altMatSection, id);

export const AltMatUrl = (id: string, params?: any) =>
  altMatPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
